import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CorretoraService {
  private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getCorretoras() {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/corretora')
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getCorretora(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/corretora/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	criaCorretora(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/corretora', {
				usuario_id: data.usuario_id,
				corretora_nome: data.corretora_nome,
				corretora_email: data.corretora_email,
				corretora_tel1: data.corretora_tel1,
				corretora_tel2: data.corretora_tel2,
				corretora_tel3: data.corretora_tel3
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	editaCorretora(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/corretora/' + data.corretora_id, {
				usuario_id: data.usuario_id,
				corretora_nome: data.corretora_nome,
				corretora_email: data.corretora_email,
				corretora_tel1: data.corretora_tel1,
				corretora_tel2: data.corretora_tel2,
				corretora_tel3: data.corretora_tel3
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	apagaCorretora(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/corretora/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}
}
